// extracted by mini-css-extract-plugin
export default {"styled":"DrugAlcoholClearinghouse_styled__zb3z0"};